export default Object.freeze({
    backward: 'backward',
    forward:  'forward',
});
